// import React, { useState } from "react";
// import axiosInstance from "../../axios";
// import {  useNavigate } from "react-router";
// import { useTranslation } from "react-i18next";
// import OverlayContainer from "@components/Overlay/OverlayContainer";



// function Contact() {
//   const initialState = {
//     fullName: "",
//     email: "",
//     telephone: "",
//     companyName: "",
//     jobTitle: "",
//     contactTime: "",
//     message: "",
//   };
//   const [ContactForm, setContactForm] = useState(initialState);
//   const [error, setError] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [errorMessage, setErrorMessage] = useState([]);
//   const { t } = useTranslation();

//   const navigate=useNavigate();

//   const handleInputChange = (e) => {
//     setContactForm({ ...ContactForm, [e.target.name]: e.target.value });
//   };

//   const handleClose = () => {
//     setShowModal(false);
//     navigate("/");
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setError(true);

//     if (
//       ContactForm.fullName !== "" &&
//       ContactForm.email !== "" &&
//       isEmailAddress(ContactForm.email) !== false &&
//       ContactForm.telephone !== "" &&
//       ContactForm.contactTime !== "" &&
//       ContactForm.jobTitle !== "" &&
//       ContactForm.message !== ""
//     ) {
//       axiosInstance.post("contact-us", ContactForm).then((res) => {
//         if (!res.data.error) {
//           setShowModal(true);
//           setErrorMessage(res.data);
//         }
//       });
//     }
//   };

//   function isEmailAddress(email) {
//     var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
//     return pattern.test(email);
//   }

//   return (
//     <>
//       {showModal && (
//         <OverlayContainer>
//           <div className="alert-dialog-inner">
//             <div className="close-wrapper align-icon" onClick={handleClose}>
//               <div className="alert-dialog-close">
//                 <i className="icon check"></i>
//               </div>
//             </div>

//             <div>
//               <div className="alert-title">
//                 <div className="icon-wrapper">
//                   <img
//                     src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`}
//                     alt="check-complete"
//                   />
//                 </div>
//                 <div className="status-message">
//                   <div className="status-title">
//                     {t("contact.Contact Success")}
//                   </div>
//                   <p>{t("contact.Success Message")}</p>
//                   <p>{t("thankYou")}</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </OverlayContainer>
//       )}
//       <div className="InternalPage">
//         <section className="ContactHead">
//           <div className="internal-text">
//             <h1 className="center">{t("Contact Us")}</h1>
//           </div>
//         </section>

//         <section className="InternalBody">
//           <div className="contact-wrapper">
//             <div className="contact-left">
//               <div className="section-title">{t("Contact Us")}</div>

//               <div className="contact-col">
//                 <div className="sub-title">
//                   <span className="phone">Phone</span>
//                 </div>
//                 <p>{t("contact.Covid Message")}</p>
//               </div>

//               <div className="contact-col">
//                 <div className="sub-title">
//                   <span className="email">Email</span>
//                 </div>

//                 <div className="email-list">
//                   <ul>
//                     <li>
//                       <a href="emailto: support@smiklearn.com">
//                         support@smiklearn.com
//                       </a>
//                     </li>

//                     <li>
//                       <a href="emailto: sales@smiklearn.com">sales@smiklearn.com</a>
//                     </li>

//                     <li>
//                       <a href="emailto: social@smiklearn.com">
//                         social@smiklearn.com
//                       </a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>

//               <div className="contact-col">
//                 <div className="sub-title">
//                   <span className="location">Canada Office</span>
//                   <i className="icon flag-canada" />
//                 </div>
//                 <p>
//                   smiklearn Inc. 5770 Hurontario St, Mississauga, ON L5R 3G5,
//                   Canada.
//                 </p>
//                 <div className="map-wrapper">
//                   <iframe
//                     width="100%"
//                     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2888.3058999769682!2d-79.67634268512072!3d43.62099176253185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b40985d188907%3A0x789e3170cf11e986!2s5770%20Hurontario%20St%2C%20Mississauga%2C%20ON%20L5R%203G5%2C%20Canada!5e0!3m2!1sen!2sin!4v1585921208871!5m2!1sen!2sin"
//                     height="300"
//                     frameBorder="0"
//                   ></iframe>
//                 </div>

//                 <div className="sub-title">
//                   <span className="location">US Office</span>
//                   <i className="icon flag-usa" />
//                 </div>
//                 <p>smiklearn Inc. 2035 N Mason Road, Suite 504, Katy, TX 77449</p>
//                 <div className="map-wrapper">
//                   <iframe
//                     width="100%"
//                     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2888.3058999769682!2d-79.67634268512072!3d43.62099176253185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b40985d188907%3A0x789e3170cf11e986!2s5770%20Hurontario%20St%2C%20Mississauga%2C%20ON%20L5R%203G5%2C%20Canada!5e0!3m2!1sen!2sin!4v1585921208871!5m2!1sen!2sin"
//                     height="300"
//                     frameBorder="0"
//                   ></iframe>
//                 </div>

//                 <div className="sub-title">
//                   <span className="location">India Office</span>
//                   <i className="icon flag-india" />
//                 </div>
//                 <p>
//                   702, Ivory Terrace, Opp. Circuit House R. C. Dutt Road,
//                   Vadodara - 07 Gujarat, India
//                 </p>
//                 <div className="map-wrapper">
//                   <iframe
//                     src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1845.5925224022792!2d73.17475275568911!3d22.308840421927247!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa7b5274fae1b51d5!2sWebmyne+Systems+Pvt.+Ltd.!5e0!3m2!1sen!2sin!4v1432561667772"
//                     width="100%"
//                     height="300"
//                     frameBorder="0"
//                   ></iframe>
//                 </div>
//               </div>
//             </div>

//             <div className="contact-right">
//               <form action="" onSubmit={handleSubmit}>
//                 <div className="form-main">
//                   <div className="section-title">{t("contact.Request CB")}</div>

//                   <div className="form-wrapper">
//                     <div
//                       className={`form-wrap ${
//                         ContactForm.fullName === "" && error === true
//                           ? "form-error"
//                           : ""
//                       }`}
//                     >
//                       <label className="control-label ">Full Name</label>
//                       <input
//                         type="text"
//                         name="fullName"
//                         id="fullName"
//                         autoComplete="off"
//                         placeholder={t("fullName")}
//                         className={`form-control ${
//                           ContactForm.fullName === "" &&
//                           error === true &&
//                           "error"
//                         }`}
//                         onChange={handleInputChange}
//                       />
//                     </div>

//                     <div
//                       className={`form-wrap ${
//                         ContactForm.email === "" && error === true
//                           ? "form-error"
//                           : ""
//                       }`}
//                     >
//                       <label className="control-label ">email</label>
//                       <input
//                         type="text"
//                         name="email"
//                         autoComplete="off"
//                         id="email"
//                         placeholder="email"
//                         className={`form-control ${
//                           ContactForm.email === "" && error === true && "error"
//                         }`}
//                         onChange={handleInputChange}
//                       />
//                       <p>
//                         {error === true &&
//                         !isEmailAddress(ContactForm.email) ? (
//                           <p className="error-text">Please enter valid email</p>
//                         ) : (
//                           ""
//                         )}
//                       </p>
//                     </div>
//                   </div>

//                   <div className="form-wrapper">
//                     <div
//                       className={`form-wrap ${
//                         ContactForm.telephone === "" && error === true
//                           ? "form-error"
//                           : ""
//                       }`}
//                     >
//                       <label className="control-label ">telephone Number</label>
//                       <input
//                         type="number"
//                         name="telephone"
//                         id="telephone"
//                         autoComplete="off"
//                         placeholder="Phone Number"
//                         className={`form-control ${
//                           ContactForm.telephone === "" &&
//                           error === true &&
//                           "error"
//                         }`}
//                         onChange={handleInputChange}
//                       />
//                     </div>

//                     <div className="form-wrap">
//                       <label className="control-label ">companyName Name</label>
//                       <input
//                         type="text"
//                         name="companyName"
//                         id="companyName"
//                         autoComplete="off"
//                         placeholder="Company Name (optional)"
//                         className="form-control"
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>

//                   <div className="form-wrapper">
//                     <div
//                       className={`form-wrap dd ${
//                         ContactForm.jobTitle === "" && error === true
//                           ? "form-error"
//                           : ""
//                       }`}
//                     >
//                       <label className="control-label ">Are you ?</label>
//                       <select
//                         aria-label="jobTitle"
//                         defaultValue=""
//                         name="jobTitle"
//                         id="jobTitle"
//                         autoComplete="off"
//                         placeholder=" Are you ?"
//                         className={`form-control ${
//                           ContactForm.jobTitle === "" &&
//                           error === true &&
//                           "error"
//                         }`}
//                         onChange={handleInputChange}
//                       >
//                         <option value="" disabled hidden>
//                           Are you?
//                         </option>
//                         <option value="Student">Student</option>
//                         <option value="Instructor">Instructor</option>
//                         <option value="Organization">Organization</option>
//                       </select>
//                     </div>
//                     <div
//                       className={`form-wrap ${
//                         ContactForm.contactTime === "" && error === true
//                           ? "form-error"
//                           : ""
//                       }`}
//                     >
//                       <label className="control-label ">Date</label>
//                       <input
//                         aria-label="contactTime"
//                         type="datetime-local"
//                         name="contactTime"
//                         id="contactTime"
//                         autoComplete="off"
//                         className={`form-control ${
//                           ContactForm.contactTime === "" &&
//                           error === true &&
//                           "error"
//                         }`}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                   <div
//                     className={`form-wrapper ${
//                       ContactForm.message === "" && error === true
//                         ? "form-error"
//                         : ""
//                     }`}
//                   >
//                     <label className="control-label">Write your message</label>
//                     <textarea
//                       name="message"
//                       rows="4"
//                       cols="50"
//                       id="message"
//                       autoComplete="off"
//                       placeholder="Write your message"
//                       className={`form-control ${
//                         ContactForm.message === "" && error === true && "error"
//                       }`}
//                       onChange={handleInputChange}
//                     ></textarea>
//                   </div>
//                   <div className="form-wrapper">
//                     <button className="submit-btn btn" type="submit">
//                       SUBMIT
//                     </button>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// }

// export default Contact;

import Contact_Home from "../Contactus/HomeBanner";
import FooterNav from "./FooterNav";
import Enquiries from "../Contactus/Enquires";
import Navbar from "../About/Navbar";
import RegisteredOffices from "../Contactus/RegisteredOffices";

function Contact() {
  return (
    <div>
      {/* <FooterNav /> */}
      <div className="mt-[100px]">
        <Navbar />
      </div>
      <Contact_Home />
      <Enquiries />
      <RegisteredOffices />
    </div>
  );
}

export default Contact;
